var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentCalculators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 180,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 284,
    height: 190,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 56.5,
    y: 71.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 153.75,
    y: 71.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 175.75,
    y: 115.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 45.625,
    y: 148.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 175.75,
    y: 126.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1280",
    transform: "translate(-1014 -2192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014 2192)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h244a8 8 0 0 1 8 8v158H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h244a7.5 7.5 0 0 1 7.5 7.5v157.5h-259V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1034 2206h244a8 8 0 0 1 8 8v16h-260v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034 2206.5h244a7.5 7.5 0 0 1 7.5 7.5v15.5h-259V2214a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(1036 2215.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 -.21)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8 -.21)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16 -.21)",
    fill: "#00c243"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045 2229h222v143h-222z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1045.5 2229.5h221v142h-221z"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1508",
    width: 29,
    height: 4,
    rx: 1,
    transform: "translate(1062 2338)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1552",
    width: 25,
    height: 4,
    rx: 1,
    transform: "translate(1212 2316)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1553",
    width: 25,
    height: 4,
    rx: 1,
    transform: "translate(1212 2327)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#eaeaea",
    d: "M1046 2230h220v16h-220z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1265",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1511",
    width: 29,
    height: 29,
    rx: 4,
    transform: "translate(1219 2256)",
    fill: "#ffc1c8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1228",
    transform: "translate(357 1)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1512",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(870 2265)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1514",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(872 2274)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1513",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(867 2270)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1266",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 44,
    height: 4,
    rx: 1,
    transform: "translate(1062 2268)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1551",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(1109 2268)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1264"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 29",
    fill: "none",
    stroke: "#c7cbd1",
    strokeWidth: 1.5,
    d: "M1062 2285.5h67.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014 2199.5)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 14",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(65.5 77.5)",
    fill: "#fd0826"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 30",
    fill: "none",
    stroke: "#fd0826",
    strokeWidth: 1.5,
    d: "M1062 2285.5h27"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1267",
    transform: "translate(77.25 -7.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 44,
    height: 4,
    rx: 1,
    transform: "translate(1062 2268)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1551",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(1109 2268)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1264"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 29",
    fill: "none",
    stroke: "#c7cbd1",
    strokeWidth: 1.5,
    d: "M1062 2285.5h67.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936.75 2199.5)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 14",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(162.75 77.5)",
    fill: "#fd0826"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 30",
    fill: "none",
    stroke: "#fd0826",
    strokeWidth: 1.5,
    d: "M1062 2285.5h43.25"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1268"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 158",
    d: "M1068.875 2350.454s40.7 6 133.66-32.073",
    fill: "none",
    stroke: "#fd0826"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1013.995 2192)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 15",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(184.75 121.5)",
    fill: "#fd0826"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1013.995 2192)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 16",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(54.63 154.5)",
    fill: "#fd0826"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1269"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 159",
    d: "M1072.201 2350.586s83.906 3.109 130.033-21.752",
    fill: "none",
    stroke: "#fd0826",
    strokeDasharray: 3,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014.001 2192)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 17",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(184.75 132.5)",
    fill: "#fe8392"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentCalculators);
export default __webpack_public_path__ + "static/media/investment-calculators.3f1dd98af83355fa2af319fe30229db4.svg";
export { ForwardRef as ReactComponent };